// extracted by mini-css-extract-plugin
export default {"author":"z5a3hDJl_DgujQCYdjzl","icon":"xvsU0xePaCHjnZpMwTnf","focus-visible":"PHMoi4BeV9TguRa1hxyE"};